import { Component, Inject } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Automation, IsAutomationDraining, RunningState } from '@vendasta/automata';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';

export interface TurnOffDialogData {
  automation: Automation;
  isBuiltIn: boolean;
}

export interface TurnOffDialogResult {
  automationId: string;
  runningState?: RunningState;
}

@Component({
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    MatRadioModule,
    MatFormFieldModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    GalaxyFormFieldModule,
    GalaxyAlertModule,
  ],
  templateUrl: './turn-off-automation-dialog.component.html',
  styleUrls: ['./turn-off-automation-dialog.component.scss'],
})
export class TurnOffAutomationDialogComponent {
  automation: Automation;
  isBuiltIn: boolean;
  RunningState = RunningState;
  runningStateControl: UntypedFormControl = new UntypedFormControl([], Validators.required);

  form: UntypedFormGroup;
  automationIsDraining = false;

  title = 'AUTOMATIONS.TURN_OFF_AUTOMATION_DIALOG.TITLE';
  description = 'AUTOMATIONS.TURN_OFF_AUTOMATION_DIALOG.STOP_DRAINING.DESCRIPTION';
  action = 'AUTOMATIONS.TURN_OFF_AUTOMATION_DIALOG.TURN_OFF';

  constructor(
    public dialogRef: MatDialogRef<TurnOffAutomationDialogComponent, TurnOffDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: TurnOffDialogData,
    private readonly fb: UntypedFormBuilder,
  ) {
    this.automation = this.data.automation;
    this.isBuiltIn = this.data.isBuiltIn;
    let defaultSelection = RunningState.RUNNING_STATE_STOPPED;
    if (this.isBuiltIn) {
      defaultSelection = RunningState.RUNNING_STATE_STOPPED;
    }
    if (IsAutomationDraining(this.automation)) {
      defaultSelection = RunningState.RUNNING_STATE_STOPPED;
      this.title = 'AUTOMATIONS.TURN_OFF_AUTOMATION_DIALOG.STOP_DRAINING.TITLE';
      this.action = 'AUTOMATIONS.TURN_OFF_AUTOMATION_DIALOG.STOP_DRAINING.STOP_DRAINING';
      this.automationIsDraining = true;
    }
    this.runningStateControl.setValue(defaultSelection);
    this.form = this.fb.group({
      runningState: this.runningStateControl,
    });
  }

  continue(): void {
    this.dialogRef.close({
      automationId: this.automation.id,
      runningState: this.form.controls.runningState.value,
    });
  }
}
